import React from 'react';
import AppPage from './AppPage';
import content from './content/ios.json';

const IOSAppPage = () => <AppPage content={content} />;

export default IOSAppPage;
